'use strict';
const angular = require('angular');

import {$$ConstraintsImport} from './Constraints';
import {DomainValuesImport} from './DomainValues';

module.exports = angular.module('domain.properties', [])
  .factory('$$Constraints', $$ConstraintsImport)
  .factory('$$DomainValues', DomainValuesImport)
;



// WEBPACK FOOTER //
// ./src/js/_libs/angular-domain/domain-properties/index.js